module.exports = __webpack_public_path__ + "img/213.03ae58a5.png";